import { classNames } from '@common/application/utils/classnames';
import type { ProductDetailVO } from '@common/types/product-detail';

import { GreyLineIcon } from '@/resources/sprites-images/grey-line-icon';

import { Product } from './product';

export interface ProductsProps {
  products: (ProductDetailVO | undefined)[];
  onAdd(index: number): void;
  onRemove(index: number): void;
}

export const Products: React.FC<ProductsProps> = ({ products, onAdd, onRemove }) => {
  return (
    <tr>
      <th className="border border-black-7">
        <div className={classNames('w-28.5 h-37.5', 'pc:w-50 pc:h-98')}></div>
      </th>
      {products.map((product, index) => (
        <td
          key={String(product?.simpleProductVo?.csku) + String(index)}
          className="border border-black-7"
        >
          {product ? (
            <Product product={product} showRemove={index !== 0} onRemove={() => onRemove(index)} />
          ) : (
            <div className={classNames('pt-23.5 w-37.5 h-69', 'pc:w-62.5 pc:h-97.5')}>
              <GreyLineIcon
                className="block mx-auto w-15.5 h-15.5 cursor-pointer"
                icon="add"
                onClick={() => onAdd(index)}
              />
            </div>
          )}
        </td>
      ))}
    </tr>
  );
};
